// Requests
import PostCall from "./CommonApi";
export default function 
GetAmountDistribution(orderId,uuid) {
  //PRJ1185082, STRY0262656 - Updated the new Apigee URL
  let url =  "/v1/ovra/transaction/v5/AmountDistribution";
  let requestObject =     {
        applicationId: "OVRA",
        agencyId: "DSHS",
        uniqueIdentifier: uuid,
        orderNumber: orderId,
      };
  return PostCall(url, requestObject);
}
